import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const STAFF_TABS = [
  { label: 'Documentation', path: '/dashboard/help/documentation' },
  { label: 'Tutorials', path: '/dashboard/help/tutorials' },
];

const DEVELOPER_TAB = { label: 'Developers', path: '/dashboard/help/developers' };

export default function HelpSubnav() {
  const location = useLocation();
  const { user } = useAuth();
  const isAdmin = user?.role === 'ADMIN';
  const tabs = isAdmin ? [...STAFF_TABS, DEVELOPER_TAB] : STAFF_TABS;

  return (
    <div className="flex flex-wrap gap-2" role="tablist" aria-label="Help sections">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`);
        return (
          <Link
            key={tab.path}
            to={tab.path}
            role="tab"
            aria-selected={isActive}
            tabIndex={0}
            className={isActive
              ? 'inline-flex items-center rounded-lg bg-sky-700 px-4 py-2 text-sm font-medium text-white'
              : 'inline-flex items-center rounded-lg bg-white px-4 py-2 text-sm font-medium text-gray-700 ring-1 ring-gray-200 hover:bg-gray-50'}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
